/**
 * Intro.js options default proptypes.
 * @type {Object}
 */
export const options = {
  hidePrev: true,
  hideNext: true,
};



// WEBPACK FOOTER //
// ./src/components/intro.js-react/helpers/defaultProps.js